import moment from 'moment';
import {
  pushToFirebase, getFromFirebase, removeItemFromFirebase, updateItemInFirebase,
  getItemsFromFirebase, subscribeAddElement, setToFirebase,
} from '../../../mixins/firebase';
import datesMethods from '../../../helpers/datesMethods';

// eslint-disable-next-line no-bitwise
const uniqueId = () => ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) => (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16));

const saveLogsToLocalstorage = (logs) => {
  localStorage.setItem('allLogs', JSON.stringify(logs));
};

const saveHabitsToLocalstorage = (habits) => {
  localStorage.setItem('allHabits', JSON.stringify(habits));
};

export default {
  createHabitWithLogs({ state }) {
    const habitWithLogsArr = state.activityHabits
      .filter((habit) => datesMethods.$diffDates(moment(), habit.endDate) < 30)
      .map((habit) => {
        const logsForHabit = state.activityLogs.filter((log) => (
          log.habitLocalId === habit.localId) || log.name === habit.name);
        return {
          ...habit,
          logs: logsForHabit,
        };
      });
    state.habitsWithLogs = habitWithLogsArr;
    return habitWithLogsArr;
  },
  // logs CRUD
  async setLogsFromLocalstorage({ commit }, localstorage) {
    if (localstorage?.length > 0) {
      commit('SET_ACTIVITY_LOGS', localstorage);
    }
  },
  async setHabitsFromLocalstorage({ commit, dispatch }, localstorage) {
    if (localstorage?.length > 0) {
      commit('SET_ACTIVITY_HABITS', localstorage);
      dispatch('createHabitWithLogs');
    }
  },
  async getAllLogs({ state, commit, dispatch }, localstorage) {
    // muszę zwrócić uwagę na to, ze user moze nie mieć firebase aktynego.
    let getNewLogs = false;
    if (localstorage?.length > 0) {
      commit('SET_ACTIVITY_LOGS', localstorage);
    }
    const getLogsOnceFromFirebase = async (response) => {
      if (localstorage?.length) {
        const elementsInStorageWithoutFirekey = [...localstorage].filter((l) => !l.firekey);
        await elementsInStorageWithoutFirekey?.forEach(async (log) => {
          await dispatch('addActivityLog', log);
        });
      }
      // create localId for old logs (to remove) muszę się zastanowić jak dodać habitLocalId
      const elementWithoutLocalId = response.filter((l) => !l.localId);
      if (elementWithoutLocalId.length) elementWithoutLocalId.forEach((l) => updateItemInFirebase('activityLogs', { ...l, localId: uniqueId() }));
      const logsWithoutHabitLocalId = response.filter((l) => !l.habitLocalId);
      // eslint-disable-next-line max-len
      // to remove after migrate
      logsWithoutHabitLocalId.forEach((l) => {
        const habit = state.activityHabits.find((h) => l.habitId === h.firekey);
        if (!habit) {
          const habitByName = state.activityHabits.find((h) => l.name === h.name);
          updateItemInFirebase('activityLogs', { ...l, habitLocalId: habitByName.localId });
          return;
        }

        updateItemInFirebase('activityLogs', { ...l, habitLocalId: habit.localId });
      });
      commit('SET_ACTIVITY_LOGS', response);
      // const logsWithoutFirekey = response.filter((l) => !l.firekey);

      getNewLogs = true;
      saveLogsToLocalstorage(response);
    };
    await getFromFirebase('activityLogs', getLogsOnceFromFirebase);
    const newElementFromFirebase = (newLog) => {
      if (!getNewLogs) return;
      // tutaj mogę obsuzyc eventy z innego komputera
      if (newLog.logFromWebhook) {
        const habit = state.activityHabits.find((h) => newLog.habitId === h.firekey);
        const newLocalObject = {
          ...newLog,
          habitLocalId: habit.localId,
          localId: uniqueId(),
        };
        dispatch('addActivityLogWithoutFirebase', newLocalObject);
      }
    };
    // nie obsługujemy dobrze serii, itd
    await subscribeAddElement('activityLogs', newElementFromFirebase);
  },
  async addActivityLogWithoutFirebase({ state, commit, dispatch }, logObject) {
    const isElementExist = state.activityLogs.filter((e) => e.firekey === logObject.firekey);
    if (isElementExist.length > 0) return;
    commit('ADD_HABIT_LOG', logObject);
    dispatch('updateActivityLog', logObject);
    saveLogsToLocalstorage(state.activityLogs);
  },
  async addActivityLog({ state, commit }, logObject) {
    if (navigator.onLine) {
      const response = await pushToFirebase('activityLogs', logObject);
      await commit('ADD_HABIT_LOG', { ...logObject, firekey: response || null });
    } else {
      await commit('ADD_HABIT_LOG', { ...logObject });
    }
    saveLogsToLocalstorage(state.activityLogs);
  },
  async removeLogById({ state, commit }, log) {
    await commit('REMOVE_HABIT_LOG', log);
    await removeItemFromFirebase('activityLogs', log.firekey);
    saveLogsToLocalstorage(state.activityLogs);
  },
  async removeActivityLog({ state, commit }, { habit, day }) {
    const findLogToRemove = (h) => {
      const allLogsForThisDay = h.logs.filter((l) => datesMethods.$isSame(l.date, day));
      return allLogsForThisDay[allLogsForThisDay.length - 1];
    };
    const log = findLogToRemove(habit);
    await commit('REMOVE_HABIT_LOG', log);
    await removeItemFromFirebase('activityLogs', log.firekey);
    saveLogsToLocalstorage(state.activityLogs);
  },
  updateActivityLog(context, log) {
    updateItemInFirebase('activityLogs', log);
  },
  addRemoveActivityLog(context, logObject) {
    pushToFirebase('removeActivityLogs', logObject);
  },
  // logs CRUD END //

  // Habits CRUD
  async getAllHabits({ commit, dispatch }) {
    let response = await getItemsFromFirebase('activityHabits');
    // create localId for old habits (to remove)
    if (!response) return;
    const updatedDatabase = response.filter((h) => !h.localId);
    updatedDatabase.forEach((h) => updateItemInFirebase('activityHabits', { ...h, localId: uniqueId() }));
    if (updatedDatabase?.length) response = await getItemsFromFirebase('activityHabits');
    saveHabitsToLocalstorage(response);

    commit('SET_ACTIVITY_HABITS', response);
    dispatch('createHabitWithLogs');
    dispatch('getGroupsOfHabits');
  },
  async addActivityHabits({ rootState, dispatch }, HabitsObject) {
    try {
      // When you are not logged in you should not add globalId (FIREBASE)
      const globalHabitId = await pushToFirebase('habits', { userId: rootState.userStore.user.uid }, true);
      const habit = await pushToFirebase('activityHabits', { ...HabitsObject, globalId: globalHabitId });
      await updateItemInFirebase('habits', { ...HabitsObject, habitId: habit, firekey: globalHabitId }, true);
      const habitChangelog = {
        type: 'create',
        date: moment().toISOString(),
        habitElement: HabitsObject,
        habitFirekey: habit,
      };
      await pushToFirebase('habitChangelog', habitChangelog);
      return { ...HabitsObject, firekey: habit, globalId: globalHabitId };
    } catch (err) {
      console.log(err);
      return {};
    } finally {
      dispatch('getAllHabits');
    }
  },
  async editActivityHabits({ dispatch }, habitElement) {
    try {
      const habitChangelog = {
        type: 'edit',
        date: moment().toISOString(),
        habitElement,
        habitFirekey: habitElement.firekey,
      };
      await pushToFirebase('habitChangelog', habitChangelog);
      updateItemInFirebase('activityHabits', habitElement);
    } catch (err) {
      console.log(err);
    }

    dispatch('getAllHabits');
  },
  // Habits CRUD END //

  selectDay({ commit }, day) {
    commit('SET_SELECT_DAY', day);
  },

  async createGlobalId({ rootState, dispatch }, HabitsObject) {
    const globalHabitId = await pushToFirebase('habits', { userId: rootState.userStore.user.uid }, true);
    await updateItemInFirebase('habits', { ...HabitsObject, habitId: HabitsObject.firekey, firekey: globalHabitId }, true);
    dispatch('editActivityHabits', { ...HabitsObject, firekey: HabitsObject.firekey, globalId: globalHabitId });
    return globalHabitId;
  },
  getGroupsOfHabits({ commit }) {
    getItemsFromFirebase('habitsGroups').then((resposne) => {
      commit('SET_GROUPS_OF_HABITS', resposne.map((e) => ({ ...e, habits: e.habits || [], show: false })));
    });
  },
  setGroupsOfHabits({ commit }, habitsGroups) {
    commit('SET_GROUPS_OF_HABITS', habitsGroups);
    setToFirebase('habitsGroups', habitsGroups);
  },
  createNewGroup({ state, commit }, group) {
    const newGroup = {
      name: group.name,
      id: uniqueId(),
      habits: [],
    };

    commit('CREATE_NEW_GROUP', newGroup);
    setToFirebase('habitsGroups', state.habitsGroups);
  },
  async removeGroup({ commit }, group) {
    commit('REMOVE_GROUP', group);
  },
};
